import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back, admin.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-ink flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-20" />
      <div className="relative w-full max-w-sm">
        <div className="bg-brand-ivory rounded-3xl p-8 shadow-2xl">
          <Logo />
          <h1 className="mt-7 font-display text-2xl font-extrabold text-brand-deep tracking-tight">Admin Panel</h1>
          <p className="mt-1 text-sm text-brand-charcoal/55">Sign in to manage products, leads and content.</p>
          <form onSubmit={submit} data-testid="admin-login-form" className="mt-6 space-y-4">
            <div>
              <label className="label-field" htmlFor="admin-email">Email</label>
              <input
                id="admin-email"
                data-testid="admin-email-input"
                type="email"
                required
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin email"
              />
            </div>
            <div>
              <label className="label-field" htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                data-testid="admin-password-input"
                type="password"
                required
                className="input-field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full flex items-center justify-center gap-2 rounded-full bg-brand-deep py-3.5 text-sm font-bold text-white transition-all hover:bg-brand-forest disabled:opacity-60"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
